import { useDispatch, useSelector } from "react-redux";
import {
  addTask,
  updateTask,
  deleteTask,
  moveTask,
} from "../redux/slices/tasksSlice";

export const useTasks = (projectId) => {
  const dispatch = useDispatch();
  const { tasks } = useSelector((state) => state.tasks);

  const projectTasks = tasks.filter((t) => t.projectId === projectId);

  const createTask = (task) => {
    dispatch(addTask({ ...task, projectId }));
  };

  const editTask = (id, updates) => {
    dispatch(updateTask({ id, updates }));
  };

  const removeTask = (id) => {
    dispatch(deleteTask(id));
  };

  const moveTaskToBoard = (taskId, targetBoardId) => {
    dispatch(moveTask({ taskId, targetBoardId }));
  };

  return {
    tasks: projectTasks,
    createTask,
    editTask,
    removeTask,
    moveTaskToBoard,
  };
};
